// @ts-nocheck
import * as types from '../types';

const initialState = {
    addresses: {
        list: [],
        current: null,
        listFetching: false,
        currentFetching: false,
    },
    groups: {
        list: [],
        current: null,
        listFetching: false,
        currentFetching: false,
    },
};

const emails = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case types.EMAIL_ADDRESS_LIST_CHANGED: {
            return {
                ...state,
                addresses: {
                    ...state.addresses,
                    list: payload,
                },
            };
        }
        case types.EMAIL_ADDRESS_LIST_FETCHING: {
            return {
                ...state,
                addresses: {
                    ...state.addresses,
                    listFetching: payload,
                },
            };
        }
        case types.EMAIL_ADDRESS_CHANGED: {
            return {
                ...state,
                addresses: {
                    ...state.addresses,
                    current: payload,
                },
            };
        }
        case types.EMAIL_ADDRESS_FETCHING: {
            return {
                ...state,
                addresses: {
                    ...state.addresses,
                    currentFetching: payload,
                },
            };
        }
        case types.EMAIL_GROUP_LIST_CHANGED: {
            return {
                ...state,
                groups: {
                    ...state.groups,
                    list: payload,
                },
            };
        }
        case types.EMAIL_GROUP_LIST_FETCHING: {
            return {
                ...state,
                groups: {
                    ...state.groups,
                    listFetching: payload,
                },
            };
        }
        case types.EMAIL_GROUP_CHANGED: {
            return {
                ...state,
                groups: {
                    ...state.groups,
                    current: payload,
                },
            };
        }
        case types.EMAIL_GROUP_FETCHING: {
            return {
                ...state,
                groups: {
                    ...state.groups,
                    currentFetching: payload,
                },
            };
        }
        default: {
            return state;
        }
    }
};

export default emails;
